import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import axios from "axios";
import LocalStorageService from "./LocalStorageService";
import webAppConfig from "../commons/webApp.config";
import { commonStore } from "./commonStore";
import { clientStore } from "./clientStore";
import { classificationStore } from "./classificationStore";
import appLogo from "../../assets/images/logo/inistate-logo.png";

const requestConfig = {
  baseURL: webAppConfig.baseURL,
};

// function getClient() {
//   let client = axios.create({
//     ...requestConfig,
//     headers: {
//       "Content-Type": "application/json",
//       "Authorization": "Bearer " + LocalStorageService.getAccessToken(),
//     },
//   });
//   // Interceptors
//   client.interceptors.response.use((response) => {
//     return response;
//   }, function (error) {
//     const originalRequest = error.config;
//     if (error.response && error.response.status === 401 && !originalRequest._retry) {
//         let localStorage = LocalStorageService;
//         originalRequest._retry = true;
//         const config = {
//           ...requestConfig,
//           headers: {
//             'Content-Type': 'application/x-www-form-urlencoded'
//           }
//         };
//         const data = `grant_type=refresh_token&refresh_token=${localStorage.getRefreshToken()}`;
//         return axios.post('/token', data, config)
//           .then(res => {
//             if (res.status === 200) {
//               localStorage.setToken(res.data);
//               client.defaults.headers['Authorization'] = 'Bearer ' + localStorage.getAccessToken();
//               originalRequest.headers['Authorization'] = 'Bearer ' + localStorage.getAccessToken();
//               return axios(originalRequest);
//             }
//           })
//           .catch(err => {
//             console.error(['Authorization:Interceptor'], err);
//             authorizationStore.dispatch('logout');
//           });
//     } else if (error.response && error.response.status === 401) {
//       authorizationStore.dispatch('logout');
//     } else {
//       console.error(['Authorization:Interceptor'], error);
//     }
//     return Promise.reject(error);
//   });
//   return client;
// }

const setAuth = (authData, state) => {
  state.logoutError = null;
  LocalStorageService.setToken(authData);
  let commonClient = commonStore.state.client;
  commonClient.defaults.headers['Authorization'] = "Bearer " + authData.access_token;
  // state.client = getClient();
  state.client = commonStore.state.client;
}

export const authorizationStore = new Vuex.Store({
  state: {
    // client: getClient(),
    client: commonStore.state.client,
    userName: LocalStorageService.getUserName(),
    roles: LocalStorageService.getRoles(),
    userProfile: {},
    appConfig: null,
    logoutError: null,
    runAs: null
  },
  mutations: {
    setUserName(state, payload) {
      state.userName = payload;
    },
    setRoles(state, data) {
      state.roles = data;
    },
    setAPIKey(state, data) {
      state.userProfile = {
        ...state.userProfile,
        apiKey: data
      }
    },
    setUserProfile(state, data) {
      state.userProfile = {
        ...data,
        userName: state.userName || LocalStorageService.getUserName(),
      }
    },
    setAppConfig(state, data) {
      state.appConfig = data;
    }
  },
  actions: {
    async refreshToken({ state, dispatch }, payload) {
      const refreshToken = payload || LocalStorageService.getRefreshToken();

      if (!refreshToken || refreshToken == 'undefined') {
        dispatch('logout', { status: 461 });
        throw new Error('461 No Refresh Token.');
      }

      const maxRetries = 3;
      for (let retryCount = 1; retryCount <= maxRetries; retryCount++) {
        try {
          const res = await axios.post(
            '/token',
            `grant_type=refresh_token&refresh_token=${refreshToken}`,
            {
              ...requestConfig,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          );

          setAuth(res.data, state);
          break;
        } catch (err) {
          console.error(`Authorization:RefreshToken. Attempt ${retryCount}.`, err);
          const errorResponseStatus = err.response && err.response.status;

          if (retryCount >= maxRetries || errorResponseStatus === 401) {
            console.error("Authorization:RefreshToken. Autologout.", err);
            let status = null;
            if (errorResponseStatus === 400) {
              status = 462;
            } else if (errorResponseStatus == 500) {
              status = 463;
            }
            dispatch('logout', { status: status });
            throw err;
          }

          await new Promise(resolve => setTimeout(resolve, 1000));
        }
      }
    },
    async login({ state }, payload) {
      try {
        let url = null;

        if(payload.secret) {
          url = 'grant_type=password&username=' + payload.username + '&password=' + encodeURIComponent(payload.password) + '&secret=' + payload.secret + '&otp=' + payload.otp;
        } else if (payload.otp) {
          url = 'grant_type=password&username=' + payload.username + '&password=' + encodeURIComponent(payload.password) + '&otp=' + payload.otp;
        } else {
          url = 'grant_type=password&username=' + payload.username + '&password=' + encodeURIComponent(payload.password);
        }

        const res = await axios.post(
            '/token',
            url,
            {
              ...requestConfig,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
            }
          );

        if (res.data) {
          setAuth(res.data, state);
        } else {
          throw 'error';
        }
      } catch (err) {
        console.error("[Authorization]", err);
        throw err;
      }
    },
    async getDemoAuthCode({ }, payload) {
      return await axios.get('/api/workspace/demotoken/' + payload, requestConfig);
    },
    async getDemoSolution({ }, payload) {
      return await axios.post(`https://inistate.com/api/getsolution/${payload}`);
    },
    async joinWorkspaceInformation({ }, payload) {
      return await axios.post('/api/workspace/join', payload, requestConfig);
    },
    async joinWorkspace({ state, dispatch }, payload) {
      try {
        const res = await state.client.post(
          '/api/workspace/join',
          { 'registration': payload.registration, 'code': payload.code },
          requestConfig
        );
        await dispatch('refreshToken');
        return res;
      } catch (err) {
        throw err;
      }
    },
    async createAccount({ dispatch }, payload) {
      try {
        const res = await axios.post('/api/user/create', payload, requestConfig);
        if (res.data.authCode) {
          await dispatch('refreshToken', res.data.authCode);
        } else if(payload && payload.requiresMFA) {

        } else {
          throw 'authCode undefined';
        }
      } catch (err) {
        console.error("[Authorization]", err);
        throw err;
      }
    },
    async setupWorkspace({ state, dispatch }, payload) {
      try {
        const res = await state.client.post('/api/workspace/register', payload, requestConfig);
        await dispatch('refreshToken');
        return res;
      } catch (err) {
        console.error("[Authorization]", err);
        throw err;
      }
    },
    async register({ }, payload) {
      return await axios.post('/api/workspace/register', payload, requestConfig);
    },
    async forgotPassword({ }, payload) {
      return await axios.post('/api/user/forgotpassword', payload, requestConfig);
    },
    async resetPassword({ }, payload) {
      payload.newPassword = payload.password;
      return await axios.post('/api/user/forgotpassword', payload, requestConfig);
    },
    async externalSignUp({ state }, payload) {
      try {
        const res = await axios.post('/api/user/externallogin', payload, requestConfig);
        if (res.data && res.data.authCode) {
          const auth = await axios.post(
            '/token',
            `grant_type=refresh_token&refresh_token=${res.data.authCode}`,
            {
              ...requestConfig,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
            }
          );
          if (auth.data) {
            const workspaces = await axios.get('/api/workspace?search=', {
              ...requestConfig,
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + auth.data.access_token,
              },
            });
            return {
              workspaces: workspaces.data || [],
              setAuth: () => setAuth(auth.data, state)
            }
          } else {
            throw 'failed to authenticate';
          }
        } else if (res.data.redirect) {
          return { redirect: res.data.redirect };
        } else {
          throw 'failed to login';
        }
      } catch (err) {
        console.error("[Authorization]", err);
        throw err;
      }
    },
    async externalLogin({ state }, payload) {
      let result = await axios.post('/api/user/externallogin', payload, requestConfig);
      if (result && result.data && result.data.authCode) {
        try {
          const res = await axios.post(
            '/token',
            `grant_type=refresh_token&refresh_token=${result.data.authCode}`,
            {
              ...requestConfig,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
            }
          );
          if (res.data) {
            setAuth(res.data, state);
            return true;
          } else {
            throw 'error';
          }
        } catch (err) {
          console.error("[Authorization]", err);
          throw err;
        }
      }

      return result;
    },
    async activate({ state }, payload) {
      let result = await axios.post('/api/workspace/activate', payload, requestConfig);
      if (result && result.data && result.data.authCode) {
        try {
          const res = await axios.post(
            '/token',
            `grant_type=refresh_token&refresh_token=${result.data.authCode}`,
            {
              ...requestConfig,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
            }
          );
          if (res.data) {
            const authorizationData = res.data
            localStorage.setItem('ls.authorizationData', JSON.stringify({
              access_token: authorizationData.access_token,
              refresh_token: authorizationData.refresh_token,
              /* username does not return */
              // userName: authorizationData.userName,
            }));

            var commonClient = commonStore.state.client;
            commonClient.defaults.headers['Authorization'] = "Bearer " + authorizationData.access_token;
            // state.client = getClient();
            state.client = commonStore.state.client;

            return true;
          } else {
            throw 'error';
          }
        } catch (err) {
          console.error("[Authorization]", err);
          throw err;
        }
      }

      return false;
    },
    async profile({ state, dispatch, commit }) {
      const maxRetries = 3;
      for (let retryCount = 1; retryCount <= maxRetries; retryCount++) {
        try {
          const res = await state.client.get('/api/profile');

          if (!res.data || !res.data.userName) {
            throw new Error("Profile not available or not found.");
          }

          // set userName
          commit("setUserName", res.data.userName);
          // set roles
          commit("setRoles", res.data.roles);
          // set user profile
          let userProfile = res.data;
          delete userProfile.roles;
          commit("setUserProfile", userProfile);
          // set local storage
          const lsAuthData = JSON.parse(localStorage.getItem("ls.authorizationData"));
          localStorage.setItem('ls.authorizationData', JSON.stringify({
            ...lsAuthData,
            userName: res.data.userName,
          }));
          break;
        } catch (err) {
          console.error(`Authorization:Profile. Attempt ${retryCount}.`, err);
          const errorResponseStatus = err.response && err.response.status;

          if (retryCount >= maxRetries || errorResponseStatus === 401) {
            console.error("Authorization:Profile. Autologout", err);
            dispatch('logout');
            throw err;
          }

          await new Promise(resolve => setTimeout(resolve, 1000));
        }
      }
    },
    setRoles({ commit }, payload) {
      commit('setRoles', payload);
    },
    setAPIKey({ commit }, payload) {
      commit('setAPIKey', payload);
    },
    async updateUserProfile({ state, commit }, payload) {
      try {
        await state.client.post('/api/user/update', payload);
        commit('setUserProfile', payload);
      } catch (err) {
        console.error("[Authorization]", err);
        throw err;
      }
    },
    async changePassword({ state }, payload) {
      return await state.client.post('/api/user/changepassword', payload);
    },
    async forgotPassword({ }, payload) {
      /**
       * case a: for sending forget password email
       * case b: for new password
       * e.g.  : payload => email(a,b), code(b), newPassword(b)
       */
      return await axios.post('/api/user/forgotpassword', payload, requestConfig);
    },
    logout({ state }, { status } = {}) {
      // error
      if (status) {
        if (status == 461) { // No Refresh Token
          state.logoutError = "461 No Refresh Token.";
        } else if (status == 462) { // Refresh token Error 400
          state.logoutError = "462 Invalid Refresh Token. This user may have been locked out.";
        } else if (status == 463) { // Refresh token Error 500
          state.logoutError = "463 Refresh token error.";
        } else if (status == 464) { // No security token
          state.logoutError = "464 No credentials.";
        } else if (status == 465) { // Retry 401
          state.logoutError = "465 Invalid authorization.";
        }
      }
      /* clear local storage */
      LocalStorageService.clearToken();
      LocalStorageService.clearWorkspace(webAppConfig.baseServer);
      /* reset */
      state.userName = null;
      state.roles = null;
      state.userProfile = {};
      // state.client = getClient();
      state.client = commonStore.state.client;
      state.runAs = null;
      const clients = [
        clientStore.state.client,
        classificationStore.state.client
      ];
      clients.forEach(client => {
        client.defaults.headers['wsId'] = null;
      });
      let commonClient = commonStore.state.client;
      commonClient.defaults.headers['Authorization'] = null;
      /* redirect */
      window.router.replace({ name: 'login' });
    },
    async getAPIKey({ state }) {
      return await state.client.get('/api/user/generateapikey');
    },
    setAppConfig({ commit }, payload) {
      commit('setAppConfig', payload);
    },
    setAuth({ state }, payload) {
      setAuth(payload, state);
    },
    setRunAs({ state }, payload = {}) {
      const { workspaceId, target } = payload;
      const wsId = target ? `runas:${workspaceId}:${target}` : workspaceId;
      state.runAs = target ?
        {
          wsId: `runas:${workspaceId}:${target}`,
          target: target
        } : null;
      LocalStorageService.clearWorkspace(webAppConfig.baseServer);
      const clients = [
        state.client,
        clientStore.state.client,
        classificationStore.state.client
      ];
      clients.forEach(client => {
        if (!!wsId)
          client.defaults.headers['wsId'] = wsId;
        else
          delete client.defaults.headers['wsId'];
      });
    }
  },
  getters: {
    userName: state => state.userName,
    userProfile: state => state.userProfile || {},
    userRoles: state => {
      const dict = [
        { value: "Administrator", order: 0 },
        { value: "Consultant", order: 1 },
        { value: "Workspace Admin", order: 2 },
        { value: "User Admin", order: 3 },
      ];

      if (Array.isArray(state.roles) && state.roles.length) {
        let roles = state.roles;
        if (roles.includes("Consultant") && !roles.includes("Workspace Admin")) {
          roles = roles.filter(role => role !== "Consultant");
        }

        if (roles.length) {
          return roles
            .map(x => {
              const role = dict.find(y => y.value === x);
              return role ? role : { value: x, order: 99 }
            })
            .sort((key, keyB) => key.order - keyB.order)
            .map(x => x.value)
            .join(", ");
        }
      }
      return "Member";
    },
    isAdministrator: (state, getters) =>
      getters.userRoles.indexOf("Administrator") > -1,
    isAdminUser: (state, getters) =>
      getters.userRoles.indexOf("Administrator") > -1 ||
      getters.userRoles.indexOf("Workspace Admin") > -1 ||
      getters.userRoles.indexOf("Consultant") > -1,
    isManagerUser: (state, getters) =>
      getters.userRoles.indexOf("User Admin") > -1,
    isBeta: (state, getters) =>
      getters.userRoles.indexOf("Consultant") > -1 ||
      getters.userRoles.indexOf("Administrator") > -1,
    isInternal: (state, getters) =>
      state.userName && state.userName.slice(-17) === '@gneysoftware.com' ||
      state.userName && state.userName.slice(-13) === '@inistate.com' ||
      ['admin', 'szewah'].indexOf(state.userName) > -1,
    /* development */
    isDevelopment: (state) =>
      ['jiaxiang.tan@gneysoftware.com', 'admin'].indexOf(state.userName) > -1,
    isRunAs: (state) => !!state.runAs,
    runAsWsId: (state) => state.runAs && state.runAs.wsId ? state.runAs.wsId : null,
    appName: state => state.appConfig && state.appConfig.name || 'Inistate',
    appLogo: state => state.appConfig && state.appConfig.logo || appLogo,
    appDisableThirdPartyLogin: state => Boolean(state.appConfig && state.appConfig.disableThirdPartyLogin)
  }
})